import { QueryParams } from "../../interfaces/common";
import { getBasicParamValues } from "../getParamValues";

export const generateAgencyQueryParams = (orderBy, order, searchParams): QueryParams => {
    return [
        {
            "value": orderBy || "default",
            "name": "orderBy"
        },

        {
            "value": getBasicParamValues("ori", searchParams),
            "name": "ori"
        },
        {
            "value": getBasicParamValues("secondaryOri", searchParams),
            "name": "secondaryOri"
        },
        {
            "value": getBasicParamValues("agencyCity", searchParams),
            "name": "agencyCity"
        },
        {
            "value": getBasicParamValues("agencyName", searchParams),
            "name": "agencyName"
        },
        {
            "value": getBasicParamValues("agencyState", searchParams),
            "name": "agencyState"
        },
        {
            "value": getBasicParamValues("agencyAddress", searchParams),
            "name": "agencyAddress"
        },
        {
            "value": getBasicParamValues("agencyZipcode", searchParams),
            "name": "agencyZipcode"
        },
        {
            "value": getBasicParamValues("agencyEmail", searchParams),
            "name": "agencyEmail"
        },
        {
            "value": getBasicParamValues("distributionMethod", searchParams),
            "name": "distributionMethod"
        },
        {
            "value": getBasicParamValues("reasonFingerPrinted", searchParams),
            "name": "reasonFingerPrinted"
        },
        {
            "value": "null",
            "name": "lowerInsertDate"
        },
        {
            "value": "null",
            "name": "upperInsertDate"
        },
        {
            "value": order,
            "name": "order"
        }
    ]
}